import { Quill } from 'react-quill';

function getMentionCharIndex(text, mentionDenotationChars) {
  return mentionDenotationChars.reduce(
    (prev, mentionChar) => {
      const mentionCharIndex = text.lastIndexOf(mentionChar);

      if (mentionCharIndex > prev.mentionCharIndex) {
        return {
          mentionChar,
          mentionCharIndex,
        };
      }
      return {
        mentionChar: prev.mentionChar,
        mentionCharIndex: prev.mentionCharIndex,
      };
    },
    { mentionChar: null, mentionCharIndex: -1 },
  );
}

class LogicMention {
  constructor(quill, options) {
    if (options.disableMention) return;
    this.quill = quill;
    this.options = options;
    this.showSelectionList = true;
    quill.on('editor-change', this.onTextChange);
  }

  onLogicSelect = (
    value,
    placeHolderText,
    extraInfo = [],
    tooltipTitle,
    isNew = true,
    insertPosition,
    range
  ) => {
    const mentionCharPos = isNew ? this.mentionCharPos : insertPosition;   
    const format = this.quill.getFormat(mentionCharPos);
    if (!!range) {
      this.quill.deleteText(insertPosition, range.length || 1, Quill.sources.USER);
      this.quill.setSelection(insertPosition); 
    }
    if (isNew) {
      this.quill.deleteText(
        mentionCharPos,
        this.cursorPosition - mentionCharPos,
        Quill.sources.USER,
      );
    }

    this.quill.insertEmbed(
      mentionCharPos,
      'mention',
      {
        denotationChar: this.mentionChar,
        value,
        placeHolderText,
        isLogicMention: true,
        extraInfo,
        tooltipTitle
      },
      Quill.sources.USER,
    );
    this.quill.insertText(mentionCharPos + 1, ' ', Quill.sources.USER);
    this.quill.formatText(mentionCharPos, 3, format, Quill.sources.USER);
    this.quill.setSelection(isNew ? mentionCharPos + 2 : mentionCharPos, Quill.sources.USER);
    this.showSelectionList = false;
  
  };

  convertTextToVariable = () => {
    const range = this.quill.getSelection();
    this.quill.deleteText(range.index, range.length, Quill.sources.USER);
    this.quill.insertText(range.index, this.options.mentionDenotationChars[0], Quill.sources.USER);
    this.quill.setSelection(range.index + 1, Quill.sources.USER);
    this.quill.insertText(range.index + 1, '', Quill.sources.USER); // TO trigger text change
  };

  onTextChange = (event, range, source) => {
    if (event === 'selection-change') {
      if (range == null) return;
      this.cursorPosition = range.index;
      const textBeforeCursor = this.quill.getText(this.cursorPosition - 50, 50); // Assumption that max length of variable is 10
      const { mentionChar, mentionCharIndex } = getMentionCharIndex(
        textBeforeCursor,
        this.options.mentionDenotationChars,
      );
      this.mentionChar = mentionChar;
      if (mentionCharIndex !== -1) {
        this.mentionCharPos = this.cursorPosition - (textBeforeCursor.length - mentionCharIndex);
        this.textAfter = textBeforeCursor.substring(mentionCharIndex + mentionChar.length);
        this.showSelectionList =
          (this.textAfter.trim().length !== 0 && this.textAfter.lastIndexOf(' ') === -1) ||
          (this.textAfter.trim().length === 0 &&
            this.cursorPosition - this.mentionCharPos === this.textAfter.split(' ').length);
        if (this.textAfter.length >= 0 && this.showSelectionList) {
          const containerPos = this.quill.container.getBoundingClientRect();
          const mentionCharPos = this.quill.getBounds(this.mentionCharPos);
          this.options.toggleLogicPopup(
            this.showSelectionList,
            this.textAfter.trim(),
            mentionCharPos,
            containerPos,
          );
        } else {
          this.options.toggleLogicPopup(false);
        }
      } else {
        this.options.toggleLogicPopup(false);
      }
    }
  };
}

export default LogicMention;
